import styled from 'styled-components'
import {FaTimes} from 'react-icons/fa'
import {Link as LinkRouter} from 'react-router-dom'
import {Link as LinkScroll} from 'react-scroll'

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    height: 100%;
    width: 100%;
    background-color: #037568;
    display: grid;
    align-items: center;
    left: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({isOpen}) => ( isOpen ? '100%' : '0')};
    top:  ${({isOpen}) => ( isOpen ? '0' : '-100%')};
`

export const CloseIcon = styled(FaTimes)`
    color: #fff;
`

export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
`

export const SidebarWrapper = styled.div`
    color: #fff;
`

export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 80px);
    text-align: center;

    @media screen and (max-width: 480px){
        grid-template-rows: repeat(4,60px);
    }
`

export const SidebarLink = styled(LinkScroll)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    color: #e2e2e2;
    cursor: pointer;

    &:hover{
        color: black;
        transition: 0.2s ease-in-out;
    }
`

export const SidebarBtn = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
`

export const SidebarBtnLinkReq = styled(LinkRouter)`
    border-radius: 15px;
    background: #b1cf5f;
    white-space: nowrap;
    padding: 16px 64px;
    color: #037568;
    font-size: 1.5rem;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition: all 0.2s ease-in-out;
        background-color: #1b523c;
        color: #e2e2e2;
    }
`


export const SidebarBtnLinkLogin = styled(LinkRouter)`
    border-radius: 15px;
    background: #e2e2e2;
    white-space: nowrap;
    padding: 16px 78px;
    color:#037568;
    font-size: 1.5rem;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition: all 0.2s ease-in-out;
        background-color: #1b523c;
        color: #e2e2e2;
    }
`

